import React, { Component } from 'react'
import { Form, Grid, Image, Checkbox, Button, Icon, Input, Segment, Modal, Header } from 'semantic-ui-react'
import { connect } from 'react-redux'
import InputField from '../formComponents/inputField'
import SelecTextField from '../formComponents/selectTextField'
import { DropDown } from '../formComponents/dropDown'
import Images from '../config/images'
import * as actionCreators from '../actions'
import SearchFirmList from '../formComponents/searchFirmList'
import { bolAwbFields } from '../util/supportedFields/bolAwbForm'
import _, { get } from 'lodash'
import { saveContainer, searchForMbols, mergeshipmentMbolsToTransaction, saveDutiesNonMerchandise, updateEngineBolTable, deleteFromEngineBolTable } from '../api/setFormData'
import PscHeaderReason from "./headerReason";
import { fetchSelectedReasonCodes, totalHeaderReasonSelected } from "../util";
//import {QryFuncModal} from '../../components/qryFunc';
import { QryFuncModal } from 'kx-common-components';
import { mbolButton } from '../../components/ISFForm/components/ISFHeader'
import SearchBolsModal from './searchBolsModal'
import { entryTypeFields } from '../util/supportedFields/entryType'
import { displayMasterItem } from './util/index'



const testMockEngineBolDataDONOTUSE = [{
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man1",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man2",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man3",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man4",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man5",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man6",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man7",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man8",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man9",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man10",
}, {
  "intakeShipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "shipmentId": `KX-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 1000)}`,
  "masterBolNumber": Math.floor(Math.random() * 100000000),
  "houseBolNumber": Math.floor(Math.random() * 100000000),
  "subHouseBolNumber": Math.floor(Math.random() * 100000000),
  "quantity": Math.floor(Math.random() * 1000),
  "units": "KG",
  "itNumber": Math.floor(Math.random() * 1000000),
  "itDate": Date.now() - Math.floor(Math.random() * 100100100542),
  "manifestId": "man11",
}]

let manifoldSearchResult = {
  "shipment": [
    {
        "state": {
            "shipmentId": "KX-J2J1-1790",
            "engineId": "FOO",
            "countryOfBusiness": "US",
            "modeOfTransport": "OCEAN",
            "mbol": "FVG765436765",
            "hbol": "FVG765436765",
            "nodeUuid": "e20a4b50-1608-4d4b-81c6-ce243030787c",
            "nodeType": "BILL_PAIR",
            "countryOfOrigin": "HK",
            "countryOfDestination": "US",
        },
        "statusByNodeType": {
            "US:ENTRY_ROOT": "NEW",
            "US:IN_BOND_ROOT": "NEW",
            "US:ISF_ROOT": "NEW"
        },
        "shipmentGroup": {
            "7e27846a-3119-4eb8-bcb5-233008451997": "Single: KX-J2J1-1790"
        }
    },
  ]
};

export class EngineBolForm extends Component {
  constructor() {
    super()
    this.state = {
      formInfo: {},
      manifoldSearchResult: { shipment: [] },
      editableFieldList: [],
      currentlySavingItems: {},
      sortOfBolTable: 'intakeShipmentId',
      sorrtDirectionBol: 'sortUpBol'
    }
  }

  

  componentWillMount() {
    this.selectedReasons = this.props.pscData.headerCodes ? fetchSelectedReasonCodes(this.props.pscData.headerCodes, this.props.tabName): []
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    
    const isPSC = this.selectedReasons.length  > 0 
    && ["STATE_PSC_IN_PROCESS", "STATE_PSC_READY"].includes(get(this.props, 'pscState.value.state'));

    const shouldEnableForm = isTheOwningBroker && isPSC;
    this.enableDisableFrom(shouldEnableForm);
  }

  enableDisableFrom = (enableForm) => {
    this.setState({
      "enableForm": enableForm
    })
  }
  
  render() {
    let {
      bolInfoValues,
      saveHeaderReason,
      engineBolInfo,
      shipmentId,
      entryTypeValues,
      setShipmentDocumentId,
      unitList,
      updateBOLInfoField,
      transportationInfo,
      saveBOLInfoField,
      updateITDateField,
    } = this.props

    const customerCode = _.get(this.props,"entryTypeValues.customerCode")

    let bolTableIsDisabled;
    let disableActions = false
    const isPermanentTransaction = this.props.entryTransactionStatus === "PERM";
    
    if(isPermanentTransaction){
      bolTableIsDisabled = this.state.enableForm === true ? false : this.props?.isDisabled('engineBolFormEnabled');
      disableActions = bolTableIsDisabled ;
      if(this.props?.useAggregated === "true"){
        disableActions  = true
      }
    } else{
      const isTempTransaction = !isPermanentTransaction
      bolTableIsDisabled = (this.state.enableForm === true ? false : this.props?.isDisabled('engineBolFormEnabled'));
      disableActions = true;
    }
    
  


    // let totalHeaderReasonSelected = this.props.pscData.headerCodes ? this.props.pscData.headerCodes.map((item)=>{
    //   return item.reasonCodes ? item.reasonCodes.length : 0
    // }).reduce((a, b) => a + b, 0) : 0;

    let isBlankTest = (input) => {
      if (!input) return true;
      if (input == "_BLANK_") return true;
      return false;
    }



    const columnNamesForTable = {
      "intakeShipmentId": "Shipment",
      "masterBolNumber": ["TRUCK"].includes(this.props?.modeOfTransport)?"PAPS":"MBOL",
      "houseBolNumber": "HBOL",
      "subHouseBolNumber": "Sub-house",
      "quantity": "Manifest QTY",
      "units": "UOM",
      "itNumber": "IT Number",
      // "itDate": "IT Date",
      "docLinkMiddlePane": "Docs",
      "trashIcon": "",
      //"shipmentId"
      //manifestId
    };

    const columnNameToDBName = {
      "masterBolNumber": "masterBolNumber",
      "houseBolNumber": "houseBolNumber",
      "subHouseBolNumber": "subHouseBolNumber",
      "quantity": "manifestQty",
      "units": "manifestUom",
      "itNumber": "itNumber",
      "itDate": "itDate",

    }


    const {
      sortOfBolTable,
      sorrtDirectionBol,
      editableFieldList,
      temporaryUIValue,
      currentlySavingItems,
    } = this.state;

    const showBolTable = (myEngineBolInfo) => {
      let columnNames = Object.keys(columnNamesForTable);

        let {
          setINPUTID,
          newValue,
          fieldName,
          shipmentId,
          rbCounterID,
          penClicked,
        } = this.props;

      columnNames = columnNames.filter(oneName=>["TRUCK"].includes(this.props?.modeOfTransport)?
      oneName!="houseBolNumber"
      :true)

      const sortDownBol = 'sortDownBol';
      const sortUpBol = 'sortUpBol';


      let tableSorterBolTable = (firstData, secondData) => {
        if (!sortOfBolTable) return 0;
        let sortResult;
        if (["quantity", "itDate"].includes(sortOfBolTable)) {
          sortResult = firstData[sortOfBolTable] - secondData[sortOfBolTable]
        } else {
          let firstDataMassaged = firstData[sortOfBolTable]+"";
          let secondDataMassaged = secondData[sortOfBolTable]+"";
          if(["intakeShipmentId"].includes(sortOfBolTable)){
            firstDataMassaged = firstDataMassaged.split('-').map(aaaa=>aaaa.padStart(30,"0")).join('-');//pad zeroes to shipments so 9 isn't greater than 10 in a strcmp
            secondDataMassaged = secondDataMassaged.split('-').map(aaaa=>aaaa.padStart(30,"0")).join('-');//pad zeroes to shipments so 9 isn't greater than 10 in a strcmp
          }
          sortResult = firstDataMassaged.localeCompare(secondDataMassaged)
        }


        return sortResult * (sorrtDirectionBol == sortUpBol ? 1 : -1)

      }
      let millisToDateString = (dateMillis) => {
        let convertedToDate = new Date(parseInt(dateMillis))
        if (!convertedToDate) return 'Invalid Date ' + dateMillis
        return <span title={convertedToDate + ""}>{((convertedToDate.getUTCMonth() + 1) + "").padStart(2, '0') + '/' + (convertedToDate.getUTCDate() + "").padStart(2, '0') + '/' + convertedToDate.getUTCFullYear()}</span>
      }
      
      const splitShipmentFields = [
        {id:'0', value: '0', description: 'None', hidePrefixOnOption: true},
        {id:'1', value: '1', description: 'Hold All - Release Entry when all cargo qualifies'},
        {id:'2', value: '2', description: 'Incremental - Request incremental cargo release. Entry date will be when the first portion is released'},
      ];
      return (<div>
        <div style={{position:'absolute',top:'5px',right:'22px'}}>
          <Grid.Row width='equal' className='no-gutters'>
            <Grid.Column width={'4'} >
              <Checkbox 
                style={{paddingRight:'5px', paddingTop:'8px'}}
                id={bolAwbFields.nonAms.id}
                disabled={this.state.enableForm === true ? false :  this.props?.isDisabled(bolAwbFields.nonAms.id)}
                label={bolAwbFields.nonAms.label}
                shipmentId={shipmentId}
                checked={bolInfoValues.nonAms === 1}
                onChange={() => {
                  updateBOLInfoField(
                    bolAwbFields.nonAms.id,
                    bolInfoValues.nonAms === 1 ? 2 : 1
                  )
                }}
                onBlur={() => saveBOLInfoField(bolAwbFields.nonAms.id)}
              />
            </Grid.Column>
            <Grid.Column className="noRightBorders noBorderRadius">
            <InputField
              disabled={bolTableIsDisabled}
              icon={<Image src={Images.calender_icon} />}
              isLabel={false}
              id={entryTypeFields.itDate.id}
              type='date'
              label={entryTypeFields.itDate.label}//I.T. Date input, it date input
              className='field-bg'
              selected={false}
              shipmentId={shipmentId}
              //value={bolInfoValues.itDate.epochs}
              value={bolInfoValues.itDate.epochs ? new Date((new Date(bolInfoValues.itDate.epochs).getUTCMonth() + 1) + "/" + new Date(bolInfoValues.itDate.epochs).getUTCDate() + '/' + new Date(bolInfoValues.itDate.epochs).getUTCFullYear()).getTime() : -999}
              // errors={fieldValidation.validObjects_bl["BolqwqritDate"]}
              onChange={value => {
                if (value && !isNaN(value.getTime())) {
                  value = value.getTime();
                  value = new Date(Date.UTC((new Date(value)).getFullYear(), (new Date(value)).getMonth(), (new Date(value)).getDate()))
                  updateITDateField(value.getTime())
                  saveBOLInfoField(entryTypeFields.itDate.id, value.getTime())
                } else if (value === null) {
                  updateITDateField(-999)
                  saveBOLInfoField(entryTypeFields.itDate.id, -999)
                }
              }}
            />
            </Grid.Column>
            <Grid.Column style={{minWidth:'150px'}}>
            <DropDown
              width={10}
              id={bolAwbFields.splitBill.id}
              label={"Split Shipment"}
              disabled={bolTableIsDisabled}
              className='field-bg dropdown100'
              labelClass='text-none'
              isLabel={true}
              data={splitShipmentFields}
              shipmentId={shipmentId}
              text={(displayMasterItem(bolInfoValues.splitBill + "", splitShipmentFields)||"").substring(0,20)}
              onChange={value => {
                updateBOLInfoField(
                  bolAwbFields.splitBill.id,
                  value
                )
                saveBOLInfoField('splitBill', value)
              }}
            />
            </Grid.Column>
          </Grid.Row>
        </div>
              
        <table style={{ width: '100%' }} className='rounded-corners engineBolTable'>
        <thead>
          <tr>
            {columnNames.map(oneColumnName => <td key={oneColumnName + "jgfjgjg"}
              onClick={() => {
                this.setState({
                  sortOfBolTable: oneColumnName,
                  sorrtDirectionBol: sortOfBolTable == oneColumnName && sorrtDirectionBol != sortUpBol ? sortUpBol : sortDownBol,
                  editableFieldList: []
                })
              }}
              className={"columnOf"+oneColumnName}
              style={{padding:'2px'}}
              key={"foobar" + oneColumnName}>
              
              {!['docLinkMiddlePane','trashIcon'].includes(oneColumnName) && <Icon name={
                sortOfBolTable == oneColumnName ? (
                  sorrtDirectionBol == sortUpBol ? "sort up" :
                    sorrtDirectionBol == sortDownBol ? "sort down" :
                      "question circle"
                ) :
                  "sort"} />}
              <b>{columnNamesForTable[oneColumnName]}</b>
            </td>)}
          </tr>
        </thead>
        <tbody>
          {(myEngineBolInfo?.engineBolRecord||[]).sort(tableSorterBolTable).map((oneRow, iii) => {
              if((oneRow.intakeShipmentId+"").indexOf("KN")==0)return;

            //TODO: add pagination

            
            let allowedToEditTypes = ["masterBolNumber", "houseBolNumber", "subHouseBolNumber", "itNumber", "quantity", "units"]//TODO: not sure if this list is correct!
            let uniqueRowId = oneRow.manifestId + "kgkg" + oneRow.masterBolNumber + "kgkg";
            let isDeletedRow = (this.state.deletedRows||[]).includes(uniqueRowId);
            const docisselected = (setShipmentDocumentId.getSelectedKxShipmentId()==(oneRow.intakeShipmentId+""));
            return (<tr key={uniqueRowId} className={(isDeletedRow?' deletingEngineRow ':' ')+
            (setShipmentDocumentId.getSelectedKxShipmentId()==(oneRow.intakeShipmentId+"")?' selected-row-highlight ':'')}
            onClick={()=>{
              if(!docisselected){
                setShipmentDocumentId.setShipmentDocumentId(oneRow.intakeShipmentId);
              }
            }}
            style={isDeletedRow?{textDecoration:'line-through',color:'#bbb',pointerEvents:'none'}:{}}
            >
              {columnNames.map(oneColumnName => {
                let mykeyforhbol = oneRow.manifestId + "kgkg" + oneRow.masterBolNumber + "kgkg" + "foobar" + oneColumnName;
                let ishbolThatLooksLikeMbol = (oneColumnName=="subHouseBolNumber" && oneRow["masterBolNumber"] == oneRow["subHouseBolNumber"]) 
                  || (oneColumnName=="houseBolNumber" && oneRow["masterBolNumber"] == oneRow["houseBolNumber"]);
                let editablexx = allowedToEditTypes.includes(oneColumnName);
                if(bolTableIsDisabled)editablexx=false;
                const uniqueCellId = oneColumnName + "xxxxxx" + oneRow.shipmentId + uniqueRowId;
                if(ishbolThatLooksLikeMbol && !editableFieldList.includes(uniqueCellId)){
                  if(!editablexx)return <td style={{padding:'0px'}} key={mykeyforhbol}></td>
                  return <td style={{padding:'0px'}} key={mykeyforhbol} onClick={()=>{
                    this.setState({ editableFieldList: [uniqueCellId], temporaryUIValue: oneRow[oneColumnName] })
                  
                  }}><span style={{opacity:'0.1'}}>&nbsp;Edit</span> {editablexx && <Icon style={{marginLeft:'4px', opacity:'0.1'}} name="pencil" />}</td>
                }
                return <td style={{
                  whiteSpace: 'nowrap',
                  padding: '2px',
                  cursor: editablexx ? 'pointer' : 'auto',
                }}
                  className={"columnOf"+oneColumnName}
                  key={mykeyforhbol}
                >
                  {
                    editableFieldList.includes(uniqueCellId) ?/*start edit cell!!!*/(
                    oneColumnName=="units"?
                      <DropDown
                        data={unitList}
                        text={oneRow[oneColumnName]}
                        disabled={ bolTableIsDisabled || currentlySavingItems[uniqueCellId]}
                        onChange={(newValue)=>{
                          if (isDeletedRow) return;
                          // this.setState({ editableFieldList: [] })
                          if (newValue != oneRow[oneColumnName]) {
                            if(currentlySavingItems[uniqueCellId])return;
                            this.setState({currentlySavingItems:{...currentlySavingItems, [uniqueCellId]: true}});
                            updateEngineBolTable(oneRow.manifestId, columnNameToDBName[oneColumnName], newValue, oneRow.shipmentId).then(resssult => {
                              this.setState({currentlySavingItems:{...currentlySavingItems, [uniqueCellId]: false}});
                              console.log('resssult: ', resssult);
                              if (resssult?.success == "true" || resssult?.data?.eventMessage?.success == "true") {
                                this.setState({ uiInputMessage: "", editableFieldList: [] })
                                oneRow[oneColumnName] = newValue;
                              } else {
                                if (resssult?.errorResponse?.errors && resssult?.errorResponse?.errors.length) {
                                  this.setState({ uiInputMessage: `FAILURE: ${resssult?.errorResponse?.errors[0]?.stacktrace.join(" ").replaceAll(/kxToken":"[^"]*"/g, "kxToken\":\"\"")}` })
                                } else {
                                  this.setState({ uiInputMessage: `FAILURE: ${JSON.stringify(resssult).replaceAll(/kxToken":"[^"]*"/g, "kxToken\":\"\"")}` })
                                }
                              }

                            })
                          }
                          
                        }}
                        />
                    :
                      <>{(()=>{

                          let savingFunction = (newValueChosen = null) => {
                            if (isDeletedRow) return;
                            // this.setState({ editableFieldList: [] })
                            let inputValueAndIsDifferent = (newValueChosen && newValueChosen != oneRow[oneColumnName]);
                            if (inputValueAndIsDifferent || temporaryUIValue != oneRow[oneColumnName]) {
                              if (currentlySavingItems[uniqueCellId]) return;
                              this.setState({ currentlySavingItems: { ...currentlySavingItems, [uniqueCellId]: true } });
                              let userMasterBolInstead = "";
                              if (oneColumnName === "houseBolNumber" && !temporaryUIValue) {
                                userMasterBolInstead = oneRow["masterBolNumber"]
                              }
                              updateEngineBolTable(oneRow.manifestId, columnNameToDBName[oneColumnName], newValueChosen || userMasterBolInstead || temporaryUIValue || " ", oneRow.shipmentId).then(resssult => {
                                this.setState({ currentlySavingItems: { ...currentlySavingItems, [uniqueCellId]: false } });
                                console.log('resssult: ', resssult);
                                if (resssult?.success == "true" || resssult?.data?.eventMessage?.success == "true") {
                                  if(document.getElementById(uniqueCellId+shipmentId) != document?.activeElement){
                                    this.setState({ uiInputMessage: "", editableFieldList: [] })
                                  }
                                  oneRow[oneColumnName] = temporaryUIValue;
                                } else {
                                  if (resssult?.errorResponse?.errors && resssult?.errorResponse?.errors.length) {
                                    this.setState({ uiInputMessage: `FAILURE: ${resssult?.errorResponse?.errors[0]?.stacktrace.join(" ").replaceAll(/kxToken":"[^"]*"/g, "kxToken\":\"\"")}` })
                                  } else {
                                    this.setState({ uiInputMessage: `FAILURE: ${JSON.stringify(resssult).replaceAll(/kxToken":"[^"]*"/g, "kxToken\":\"\"")}` })

                                  }
                                }

                              });
                            }
                          }

                        
                        return (<InputField
                        onFocus={()=>{
                          if (isDeletedRow) return;
                          this.setState({temporaryUIValue:oneRow[oneColumnName]})
                        }}
                        type={oneColumnName == 'itDate' ? "date":"text"}
                        value={["_BLANK_","N/A"].includes(temporaryUIValue)?"":temporaryUIValue}
                        id={uniqueCellId}
                        saveOnTabOut={true}
                        disabled={ bolTableIsDisabled}
                        onChange={(value)=>{
                          if (isDeletedRow) return;
                          this.setState({ temporaryUIValue: value })
                          if(oneColumnName == 'itDate'){
                            let splitted = (value+"").split("-");
                            if(splitted.length >= 3){
                            let convertFromYYYYMMDD = (value+"").split("-")
                              savingFunction(Date.UTC(convertFromYYYYMMDD[0],parseInt(convertFromYYYYMMDD[1]) - 1/*javascript!*/,convertFromYYYYMMDD[2],12));
                            } else {
                            window.alert("Couldn't save Date "+value);
                            }
                          }

                        }}
                        onBlur={(value) => {
                          savingFunction(this.state.temporaryUIValue);
                          
                        }}
                        className={"extraShortInput"}
                        style={{ padding: '1px', width:'100%' }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />);
                    
                    })()}</>
                    )/*end edit cell!!!*/:
                      <>
                        {oneColumnName == 'masterBolNumber' && <span style={{display:'inline-block'}}>
                          {mbolButton({modeOfTransport: this.props?.modeOfTransport, masterBolNumber: ""+oneRow['masterBolNumber'] }, oneRow.intakeShipmentId)}
                        </span>}
                        {oneColumnName == 'houseBolNumber' && 
                          <div style={{ display: 'inline-block' }}>
                            <QryFuncModal
                              brokerId={window.brokerId}
                              launchFrom={'ISF_HEADER'}
                              hideLeftPanel={true}
                              dataType={'BOL'}
                              width={'75%'}
                              shipId={oneRow.intakeShipmentId}
                              value={oneRow['houseBolNumber']}
                              bolNum={oneRow['houseBolNumber']}
                              mBol={oneRow['masterBolNumber']}
                              recentQryCall={false}
                              baseUrl={window._env_.REACT_APP_BROKER_API_URL}
                              mot={this?.props?.modeOfTransport}
                              buttontext={<Icon
                                name='info circle'
                                color='blue'
                                style={{ cursor: 'pointer' }}
                              />
                              }
                            />
                          </div>}
                        <span
                          onClick={() => {
                            
                            this.setState({
                              editableFieldList: []
                            });
                            if (isDeletedRow) return;
                            if (!editablexx) return
                            this.setState({ editableFieldList: [uniqueCellId], temporaryUIValue: oneRow[oneColumnName] })
                            setTimeout(() => {
                              document.getElementById(uniqueCellId) && document.getElementById(uniqueCellId).focus();
                            }, 10)
                          }}>
                            {oneColumnName == 'itDate' ? 
                              millisToDateString(oneRow[oneColumnName])
                              :["_BLANK_","N/A"].includes(oneRow[oneColumnName])?""
                              :oneRow[oneColumnName]
                            }
                            
                          {editablexx && <Icon style={{marginLeft:'4px', opacity:'0.1'}} name="pencil" />}
                          
                          </span>
                      </>}


  
                        {/* {oneColumnName == 'houseBolNumber' &&  <span style={{display:'inline-block'}}>
                        {mbolButton({modeOfTransport: this.props?.modeOfTransport, masterBolNumber: ""+oneRow['houseBolNumber'] }, oneRow.intakeShipmentId)}</span>} */}

                      
                      
                      {(currentlySavingItems[uniqueCellId]) && 
    <Icon loading name='spinner' style={{opacity:"0.3"}} />} 
                      
                  {oneColumnName == 'docLinkMiddlePane' && !isDeletedRow?
                  <><Icon title="Show the documents for this shipment" name="file pdf outline" size="large"  style={{ cursor: 'pointer' }} color={docisselected?'red':null} /></>
                  :null}
                  {oneColumnName == 'trashIcon' && !isDeletedRow && <>
                    {this.state.confirmDelete == uniqueRowId ? <>
                      <Icon color="green" style={{ cursor: 'pointer' }} onClick={() => { this.setState({ confirmDelete: null }) }} name="reply" />
                      <Icon color="red"  style={{ cursor: 'pointer' }} name="trash" onClick={() => {
                        deleteFromEngineBolTable(oneRow).then((deletedResp)=>{
                          if(deletedResp.data.eventMessage.success=="true"){
                            this.setState({
                              deletionErrorX: ""
                            })
                            updateBOLInfoField('engineBolInfo',{engineBolRecord:(myEngineBolInfo?.engineBolRecord||[]).filter(aaaa=>aaaa.manifestId!=oneRow.manifestId)})
                            setTimeout(()=>{
                              document.getElementById(`card-${shipmentId}`) && document.getElementById(`card-${shipmentId}`).click();
                            },300);
                          } else {
                            this.setState({deletionErrorX: _.get(deletedResp,"data.eventMessage.errorResponse.errors[0].stacktrace"),
                            deletedRows:(this.state.deletedRows||[]).filter(aaaa=>aaaa!=uniqueRowId)})
                          }
                        });
                        this.setState({confirmDelete: null,
                          deletedRows:[...(this.state.deletedRows||[]),uniqueRowId]})
                      }} />

                    </> : <>
                      <Icon color="red" style={{ visibility: 'hidden' }} name="trash alternate outline" />
                      <Icon 
                        color={disableActions?"grey":"red"} 
                        style={{cursor:disableActions?'auto':'pointer'}} 
                        onClick={() => { 
                          if(disableActions)return;
                          this.setState({ confirmDelete: uniqueRowId }) 
                        }} 
                        name="trash alternate outline" 
                      />
                    </>}


                  </>}
                </td>
              })}


            </tr>)

          })}

        </tbody>

      </table></div>)
    }
  
    return (
      <>
        {
          (get(this.props, "pscData.pscShipmentId") || this.props.isAPscShipment) &&
          <PscHeaderReason
            {...this.props}
            pscState={get(this.props, "pscState.value.state")}
            totalHeaderReasonSelected={totalHeaderReasonSelected(this.props.pscData)}
            selectedOptions={this.selectedReasons}
            saveHeaderReason={saveHeaderReason}
            enableDisableFrom={this.enableDisableFrom} />
        }
        <Grid width='equal' className='no-gutters'>




          <div style={{ margin: '5px', width: '100%' }}></div>
          {this.state.uiInputMessage && <span style={{ color: 'red' }} className="formErrorMessage"
          >
            {this.state.showAllBolErrorMessage ?
              (this.state.uiInputMessage || "")
              : (this.state.uiInputMessage || "").substring(0, 30)}
            <span style={{ color: 'blue', cursor: 'pointer' }}

              onClick={() => {
                this.setState({ showAllBolErrorMessage: !this.state.showAllBolErrorMessage });

              }}>
            {this.state.showAllBolErrorMessage?" ...LESS":" ...MORE"}
            </span>
            </span>}
          {showBolTable(engineBolInfo)}


          <span style={{color:'red'}}>{this.state.deletionErrorX}</span>
          <div style={{ margin: '5px', width: '100%' }}></div>

          {!disableActions &&
            <SearchBolsModal 
            shipmentId={shipmentId}
            entryTypeValues={entryTypeValues}
            transportationInfo={transportationInfo}
            customerCode={customerCode} 
            isDisabled={bolTableIsDisabled} />
          }





          <br />
        </Grid>
        <br />
      </>
    )
  }
}

const mapStateToProps = state => ({
  entryTypeValues: state.EntryTypeInfo,
  bolInfoValues: state.BOLInfo,
  unitList: state.DropDownValues.unitList,
  bolTypeList: state.DropDownValues.bolTypeList,
  // SCACList: state.DropDownValues.SCACList,
  manifestQuantityQuantity: state.BOLInfo.manifestQuantity.quantity,
  manifestQuantityUnits: state.BOLInfo.manifestQuantity.units,
  newValue: state.FormValues.newValue,
  fieldName: state.FormValues.fieldName,
  setINPUTID: state.FormValues.setINPUTID,
  
  penClicked: state.FormValues.penClicked,
  shipmentId: state.FormValues.shipmentId,
  engineBolInfo: state.BOLInfo.engineBolInfo,
  USportOfUnladingCode: state.TransportationInfo.USportOfUnladingCode,
  formDisabled: state.FormValues.formDisabled,
  rbCounterID: state.FormValues.rbCounterID,
  fieldValidation: state.FieldValidation,
  tabName: "bolAwb",
  pscData: state.PSC,
  useAggregated:  state.DescriptionOfMerchandise?.useAggregated
})

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EngineBolForm)
